import { h } from "preact";
import { classNames } from "../helpers";

export default function RedactedInfo({
  darker,
  inline,
  large,
  lines,
  small,
  w40,
  w80,
  w128,
  w160,
  w256,
}) {
  if (lines && lines > 1) {
    const redactedLines = [];
    for (var i = 0; i < lines; i++) {
      redactedLines.push(
        <span
          class={classNames(
            "redacted-info__line",
            inline && "redacted-info__line--inline",
            darker && "redacted-info__line--darker",
            small && "redacted-info__line--small",
            large && "redacted-info__line--large",
            w40 && "redacted-info__line--w40",
            w80 && "redacted-info__line--w80",
            w128 && "redacted-info__line--w128",
            w160 && "redacted-info__line--w160",
            w256 && "redacted-info__line--w256"
          )}
        ></span>
      );
    }
    return <div class="redacted-info--multiline">{redactedLines}</div>;
  }
  return (
    <span
      class={classNames(
        "redacted-info__line",
        inline && "redacted-info__line--inline",
        darker && "redacted-info__line--darker",
        small && "redacted-info__line--small",
        large && "redacted-info__line--large",
        w40 && "redacted-info__line--w40",
        w80 && "redacted-info__line--w80",
        w128 && "redacted-info__line--w128",
        w160 && "redacted-info__line--w160",
        w256 && "redacted-info__line--w256"
      )}
    ></span>
  );
}
